import { Identity, IsNull, IsNumber, IsString } from "@pdfking/tfunc"

import { is_function } from "./is_function"
import { map } from "./map"

/**
 * Creates property accessor from various input types.
 *
 * Converts string/number keys, functions, arrays, or objects into getter functions.
 *
 * @param e - Key (string/number), function, null, array of keys, or object map
 * @returns Getter function
 *
 * @example
 * ```ts
 * import { getter } from "@pdfking/rfunc"
 *
 * getter("a")({ a: 2 }) // 2
 * getter(["a", "b"])({ a: 2, b: 3 }) // [2, 3]
 * getter({ x: "a", z: "b" })({ a: 2, b: 3 }) // { x: 2, z: 3 }
 * getter(null)({ a: 2 }) // { a: 2 }
 * ```
 */
export const getter = e => {
  if (IsString(e) || IsNumber(e)) {
    return o => o[e]
  } else if (IsNull(e)) {
    return Identity
  } else if (is_function(e)) {
    return e
  } else {
    return o => map(v => getter(v)(o), e)
  }
}
